/**************************************************************************************************************************************************
*   MODULE NAME     :  UploadXMLFeed
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  03-05-2021
*   DESCRIPTION     :  Component to load Upload XML page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2517014
*   DESCRIPTION: <GLSD>: Layer7 API Deprecation
*   removed unused/commented code 
*   DATE: 28-Feb-2025
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2714874
*   DESCRIPTION: <GLSD>Import .XLSX file type for Japan and Global users
*   DATE: 02-Feb-2026
/**************************************************************************************************************************************************/

import React from "react";
import { Container, Row, Col, Form, Tooltip, OverlayTrigger, Button, } from "react-bootstrap";
import { FaSpinner, FaEye, FaSearch, FaTrashAlt, FaFilter, FaPlusSquare } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import swal from "sweetalert";
import DataTable from '../common/dataTable/DataTable';
import { loadAbstractsData } from "../../actions/homeActions";
import { UPLOAD_IN_BACKGROUND, DUPLICATES_IGNORED } from '../common/MessagesPool';
import "./UploadXMLFeed.css";
import { uploadAbstractAttachment } from "../../actions/abstractActions";

class UploadXMLFeed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selected: [],
            xmlReceivedDate: null,
            xmlDataList: []
        };
    }
    /**
     * Function to hide/show loader.
     * @param isLoading whether to hide or show loader
     */
    setLoader = isLoading => this.setState({ isLoading });
    /**
     * Function to initiate life cycle hooks.
     */
    componentDidMount() {
        
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                selected: [...this.state.selected, row.id]
            }));
        } else {
            this.setState(() => ({
                selected: this.state.selected.filter(x => x !== row.id)
            }));
        }
    }

    handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => r.id);
        if (isSelect) {
            this.setState(() => ({
                selected: ids
            }));
        } else {
            this.setState(() => ({
                selected: []
            }));
        }
    }
    handleDateChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleUploadXMLSubmitFunction = async (e) => {
        this.setLoader(true);
        let {xmlDataList: files, selected} = this.state;
        let formData = new FormData();
        files.map(file => {
          if(selected.includes(file.id)) {
            formData.append("file", file.file);
            formData.append("filePath", `GLSD_XML/SourceXML/${file.file.name}`);
          }
        });
        this.props.uploadAbstractAttachment(formData);
        swal('', UPLOAD_IN_BACKGROUND, 'info').then(() => {
          this.reset();
          this.setLoader(false);
        })
    }

    reset = () => {
      this.setState({
        selected: [],
        xmlDataList: []
      })
    }

    handleFileBrowse = (evt) => {
        if (!evt.target.files || evt.target.files.length === 0) return;
        let files = evt.target.files;
        let filesArray = [];
        let currSelected = []
        let {xmlDataList: dataRows} = this.state;
        let sets = new Set(dataRows.map(e => e.file.name));
        let curr = dataRows.length === 0 ? 0 : dataRows[dataRows.length - 1].id + 1;
        let reuploadError = false;
        for (let i = 0; i < files.length; i++) {
          if(sets.has(files[i].name)) {
            reuploadError = true;
            continue;
          } 
          sets.add(files[i].name)
          let file = { "id": curr++, file: files[i] };
          currSelected.push(file.id);
          filesArray.push(file);
        }
        this.setState(prevState => ({
          xmlDataList: [...prevState.xmlDataList, ...filesArray],
          selected: [...this.state.selected, ...currSelected]
        }));
        if(reuploadError) swal('', DUPLICATES_IGNORED, 'info');
    }

    render() {
        const { isLoading, xmlDataList, xmlReceivedDate, selected } = this.state;
        const xmlDataColumns = [
            {
                dataField: 'file.name',
                text: 'title',
                sort: true
            }];
            const selectRow = {
              mode: 'checkbox',
              clickToSelect: true,
              selected: selected,
              onSelect: this.handleOnSelect,
              onSelectAll: this.handleOnSelectAll
            };

        return (
          <>
            <div className="CommonWrap">
              <Container fluid>
                <div className="headerpart">
                  <h1>Upload XML</h1>
                </div>
                
                <Row>
                <Col sm={{span: 2, offset: 5}}>
                  <Form.Group controlId="imageUpload">
                    <Form.Label className={`btn btn-primary mt-4 mb-4`}>
                      Browse Files
                  </Form.Label>
                  <Form.Control
                    onClick={e => (e.target.value = null)}
                    type="file"
                    multiple={true}
                    accept=".xml, .txt, .xlsx"
                    placeholder="Browse"
                    name="imageUpload"
                    onChange={this.handleFileBrowse}
                    className="fileSelectStyle"
                  />
                </Form.Group>
                  </Col>
                </Row>
                {xmlDataList && xmlDataList.length > 0 && 
                (
                    <>
                <Row>
                  <Col sm={{span: 8, offset: 2}}>
                    <DataTable
                      keyField="id"
                      defaultSortField="date"
                      data={xmlDataList}
                      columns={xmlDataColumns}
                      selectRow={selectRow}
                      showSearch={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={{offset: 5, span: 2}} className="mt-3">
                    <Button
                      variant="primary"
                      type="button"
                      onClick={this.handleUploadXMLSubmitFunction}
                      disabled={!selected || selected.length === 0}
                    >
                      Upload
                    </Button>
                  </Col>
                </Row>
                </>
                )}
              </Container>
            </div>
            {isLoading && (
              <div className="loader">
                <FaSpinner />
              </div>
            )}
          </>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            uploadAbstractAttachment
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadXMLFeed));